import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import ActionButton from "../../shared/components/ActionButton";
import {
  DEFAULT_TABLE_HEADER_HEIGHT,
  DEFAULT_TABLE_ROW_HEIGHT
} from "../../shared/constants";
import ListViewTable from "../components/ListViewTable";
import { ListTableColumnShape, ListTablePolicyShape } from "../proptypes";

const DeletePolicies = ({
  close,
  columns,
  deletePolicies,
  orderBy,
  policies,
  saving
}) => (
  <div className="l-listview__delete-modal">
    <h4 className="l-listview__delete-modal-title">
      These policies will be deleted:
    </h4>
    <ListViewTable
      policies={policies}
      columns={columns}
      orderBy={orderBy}
      showActions={false}
      style={{
        height: `${DEFAULT_TABLE_HEADER_HEIGHT +
          policies.length * DEFAULT_TABLE_ROW_HEIGHT}px`,
        maxHeight: "calc(100vh - 13rem)"
      }}
    />
    <div className="l-listview__delete-modal-footer">
      <div className="l-flex-spaced-centered">
        <ActionButton
          type="negative"
          inProgress={saving}
          onClick={() => deletePolicies()}
        >
          {saving ? "Deleting..." : "Delete"}
        </ActionButton>
        <button
          type="button"
          className="u-no-margin--bottom"
          onClick={() => close()}
        >
          Close
        </button>
      </div>
    </div>
  </div>
);

DeletePolicies.propTypes = {
  close: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(ListTableColumnShape).isRequired,
  deletePolicies: PropTypes.func.isRequired,
  orderBy: PropTypes.arrayOf(PropTypes.string).isRequired,
  policies: PropTypes.arrayOf(ListTablePolicyShape).isRequired,
  saving: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  saving: state.policies.saving
});

export default connect(mapStateToProps)(DeletePolicies);
